// File: src/services/tipProducts/service.js
import { axios } from '../http/axios.js';
import { api } from '../../constants/api.js';

const tipProducts = {
  // Fetch an existing tip product by its ID
  fetchProduct: async (type, productId) => {
    try {
      // Example endpoint: GET /api/store/tip/:productId
      const response = await axios.get(api.store.fetchProduct(type, productId));
      return response.data;
    } catch (error) {
      console.error('Error fetching tip product:', error);
      throw error;
    }
  },

  // Create a new tip product
  createProduct: async (type, productData) => {
    try {
      // Example endpoint: POST /api/store/tip
      const response = await axios.post(api.store.createProduct(type), productData);
      return response.data;
    } catch (error) {
      console.error('Error creating tip product:', error);
      throw error;
    }
  },

  // Update an existing tip product by its ID
  updateProduct: async (type, productId, productData) => {
    try {
      const response = await axios.put(api.products.updateTipProduct(productId), productData);
      return response.data;
    } catch (error) {
      console.error('Error updating tip product:', error);
      throw error;
    }
  },

  sendTip: async ({ amount, title, description, storeName }) => {
    try {
      const response = await axios.post(api.store.createTipSession, {
        amount,
        title,
        description,
        storeName,
      });
      return response.data;
    } catch (error) {
      console.error('Error sending tip:', error);
      throw error;
    }
  },

  // Verify a tip payment
  verifyTipPayment: async (sessionId) => {
    try {
      const response = await axios.get(api.store.verifyTipPayment(sessionId));
      return response.data;
    } catch (error) {
      console.error('Error verifying tip payment:', error);
      throw error;
    }
  },
};

export default tipProducts;
// File: src/services/twilio/service.js 